export default "__VITE_ASSET__BLuYFwrV__"